<template>
    <div>
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段1</div>
            <el-select v-model="sel01"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper01"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt01" size="small" style="width:300px; height:40px; "></el-input> 
        </div> 
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段2</div>
            <el-select v-model="sel02"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper02"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt02" size="small" style="width:300px; height:40px; "></el-input> 
        </div> 
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段3</div>
            <el-select v-model="sel03"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper03"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt03" size="small" style="width:300px; height:40px; "></el-input> 
        </div> 
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段4</div>
            <el-select v-model="sel04"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper04"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt04" size="small" style="width:300px; height:40px; "></el-input> 
        </div> 
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段5</div>
            <el-select v-model="sel05"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper05"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt05" size="small" style="width:300px; height:40px; "></el-input> 
        </div>
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段6</div>
            <el-select v-model="sel06"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper06"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt06" size="small" style="width:300px; height:40px; "></el-input> 
        </div>
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段7</div>
            <el-select v-model="sel07"  placeholder="请选择列名" filterable size="small" style="width:220px;  height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper07"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt07" size="small" style="width:300px; height:40px; "></el-input> 
        </div>
        <div style=" height:40px;display:flex" >
            <div style="font-size:12px;margin-right:2px;margin-left:5px;line-height:35px;width:40px; ">字段8</div>
            <el-select v-model="sel08"  placeholder="请选择列名" filterable size="small" style="width:220px; height:40px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper08"  size="small" style="width:90px;height:40px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值"  v-model="txt08" size="small" style="width:300px; height:40px; "></el-input> 
        </div>    
        <div style="border-top:2px solid #389;margin-top:10px; line-height:30px;height:40px; "  >
            <div style=" margin-top:6px">
                <span style="font-size:12px;margin-right:4px"> 我的方案</span>
                <el-select v-model="v_schema"  @change="selChg" @clear="selClear" size="small" style="width:190px;height:30px; " clearable>
                    <span v-for="(item,index) in qryData" :key='index'>
                        <el-option :label="item.QRYNM" :value="item.PKSEQ"></el-option>
                    </span>
                </el-select>
                <el-button type="text" @click="delRec" icon="iconfont icon-shanchu1" size="small" style="margin-left:15px;margin-right:15px;font-size:12px">删除方案</el-button>
              
                <span style="font-size:12px;margin-right:4px"> 方案名称</span><el-input size="small" v-model="v_name" style="width:180px"></el-input>
                <el-button type="text" @click="saveRec" icon="iconfont icon-baocun" size="small" style="margin-left:15px;margin-right:15px;font-size:12px">保存方案</el-button>
            </div>
        </div>
        <div style="border-top:2px solid #ccc;margin-top:10px; line-height:30px;height:40px; "  >
            <span style="float:right;margin-top:4px">
                <el-button icon="iconfont icon-shanchu" type="info" @click="btnExit" size="small" style="margin-right:30px">取 消</el-button>
                <el-button icon="iconfont icon-chakan-copy" type="primary" size="small" @click="btnQry">查 询</el-button>
            </span>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

  
export default {
    props: {
        v_idseq:{
            type: Number,
        },
        v_lstseq:{
            type: Number,
        }
    },
    data () {
        return {
            promptWin:false,
            prompt:'',
            v_schema:'',
            v_name:'',
            sel01:'',
            txt01:'',
            oper01:'like',
            sel02:'',
            txt02:'',
            oper02:'like',
            sel03:'',
            txt03:'',
            oper03:'like',
            sel04:'',
            txt04:'',
            oper04:'like',
            sel05:'',
            txt05:'',
            oper05:'like',
            sel06:'',
            txt06:'',
            oper06:'like',
            sel07:'',
            txt07:'',
            oper07:'like',
            sel08:'',
            txt08:'',
            oper08:'like',
            operArr:[],
 
            v_formurl: 'xuper_auth/getTableRecMany',      
            v_username:this.$cookies.get('v_telno'), //api 请求用户
 
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            tabCol:[],
            qryData:[],
        }
    },
    created () {
 
    },
 
    mounted () {   
        //操作符
        this.$axios.post(this.v_formurl,{
            p_key:'PARENTNO',
            p_value:'15995',
            p_table:'v_sys_base',
        }).then(res=>{
            this.operArr =res.result
        })
 
        this.getTabCol(this.v_idseq,this.v_lstseq)  
        this.getMthList(this.v_idseq)
    } ,
    watch: {
        v_idseq:function(){ //侦测变量值改变时 执行此方法
            this.getTabCol(this.v_idseq,this.v_lstseq)  
        }   
    },
    methods: {  
        selClear(){
            this.sel01=''
            this.oper01='like'
            this.txt01=''
            this.sel02=''
            this.oper02='like'
            this.txt02=''
            this.sel03=''
            this.oper03='like'
            this.txt03=''
            this.sel04=''
            this.oper04='like'
            this.txt04=''
            this.sel05=''
            this.oper05='like'
            this.txt05=''
            this.sel06=''
            this.oper06='like'
            this.txt06=''
            this.sel07=''
            this.oper07='like'
            this.txt07=''
            this.sel08=''
            this.oper08='like'
            this.txt08=''
        },
        selChg(val){
            this.qryData.some(item =>{
                if (item.PKSEQ ==val){
                    this.sel01= item['SEL01']
                    this.oper01=item['OPER01']
                    this.txt01=item['TXT01']
                    this.sel02=item['SEL02']
                    this.oper02=item['OPER02']
                    this.txt02=item['TXT02']
                    this.sel03=item['SEL03']
                    this.oper03=item['OPER03']
                    this.txt03=item['TXT03']
                    this.sel04=item['SEL04']
                    this.oper04=item['OPER04']
                    this.txt04=item['TXT04']
                    this.sel05=item['SEL05']
                    this.oper05=item['OPER05']
                    this.txt05=item['TXT05']
                    this.sel06=item['SEL06']
                    this.oper06=item['OPER06']
                    this.txt06=item['TXT06']
                    this.sel07=item['SEL07']
                    this.oper07=item['OPER07']
                    this.txt07=item['TXT07']
                    this.sel08=item['SEL08']
                    this.oper08=item['OPER08']
                    this.txt08=item['TXT8']
                }
            })
        },
        //删除方案
        delRec(row){
            if (!this.v_schema){
                this.promptWin =true
                this.prompt ='请选择要删除的方案名称'
            }else {
                this.$confirm('你确定要删除此方案名称吗' +'?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    //发起删除请求
                    var vm=this;
                    let v_ind =this.v_schema.indexOf('-')
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:this.v_schema.substring(0,v_ind),p_key2:'lstseq',p_value2:this.v_schema.substring(v_ind+1),p_table:'MY_QRYMTH'},
                    }).then(res=>{      
                        if(res.code ==='200')  { 
                            this.v_schema =''          
                            this.getMthList(this.v_idseq) 
                            this.selClear()
                        }else{
                            this.promptWin =true
                            this.prompt =res.result 
                        }        
                    }) 
                }).catch(()=>{})
            }
        },
        //保存方案
        saveRec(){
            if (!this.v_name){
                this.promptWin =true
                this.prompt ='方案名称不能为空'
            }else {
                this.$confirm('你确定要保存上述条件为方案名：'+this.v_name+'?','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    let v_cond =''
                    if (this.sel01 && this.txt01){
                        if (this.oper01 =='like'){
                            v_cond =v_cond +' and lower('+this.sel01+') like lower(@#%'+this.txt01+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel01+')'+this.oper01+'  lower(@#'+this.txt01+'@#)'
                        }
                    }
                    if (this.sel02 && this.txt02){
                        if (this.oper02 =='like'){
                            v_cond =v_cond +' and lower('+this.sel02+') like lower(@#%'+this.txt02+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel02+')'+this.oper02+'  lower(@#'+this.txt02+'@#)'
                        }
                    }
                    if (this.sel03 && this.txt03){
                        if (this.oper03 =='like'){
                            v_cond =v_cond +' and lower('+this.sel03+') like lower(@#%'+this.txt03+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel03+')'+this.oper03+'  lower(@#'+this.txt03+'@#)'
                        }
                    }
                    if (this.sel04 && this.txt04){
                        if (this.oper04 =='like'){
                            v_cond =v_cond +' and lower('+this.sel04+') like lower(@#%'+this.txt04+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel04+')'+this.oper04+'  lower(@#'+this.txt04+'@#)'
                        }
                    }
                    if (this.sel05 && this.txt05){
                        if (this.oper05 =='like'){
                            v_cond =v_cond +' and lower('+this.sel05+') like lower(@#%'+this.txt05+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel05+')'+this.oper05+'  lower(@#'+this.txt05+'@#)'
                        }
                    }
                    if (this.sel06 && this.txt06){
                        if (this.oper06 =='like'){
                            v_cond =v_cond +' and lower('+this.sel06+') like lower(@#%'+this.txt06+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel06+')'+this.oper06+'  lower(@#'+this.txt01+'@#)'
                        }
                    }
                    if (this.sel07 && this.txt07){
                        if (this.oper07 =='like'){
                            v_cond =v_cond +' and lower('+this.sel07+') like lower(@#%'+this.txt07+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel07+')'+this.oper07+'  lower(@#'+this.txt07+'@#)'
                        }
                    }
                    if (this.sel08 && this.txt08){
                        if (this.oper08 =='like'){
                            v_cond =v_cond +' and lower('+this.sel08+') like lower(@#%'+this.txt08+'%@#)'
                        }else{
                            v_cond =v_cond +' and lower('+this.sel08+')'+this.oper08+'  lower(@#'+this.txt08+'@#)'
                        }
                    }
                    let v_obj={'IDSEQ':this.v_idseq,'LSTSEQ':'',CORPID:this.v_corpid,USERNO:this.v_username,QRYNM:this.v_name,SQLQRY:v_cond,
                              'SEL01':this.sel01,'OPER01':this.oper01,'TXT01':this.txt01,'SEL02':this.sel02,'OPER02':this.oper02,'TXT02':this.txt02,
                              'SEL03':this.sel03,'OPER03':this.oper03,'TXT03':this.txt03,'SEL04':this.sel04,'OPER04':this.oper04,'TXT04':this.txt04,
                              'SEL05':this.sel05,'OPER05':this.oper05,'TXT05':this.txt05,'SEL06':this.sel06,'OPER06':this.oper06,'TXT06':this.txt06,
                              'SEL07':this.sel07,'OPER07':this.oper07,'TXT07':this.txt07,'SEL08':this.sel08,'OPER08':this.oper08,'TXT08':this.txt08
                              }
                    //console.log('obj:'+JSON.stringify(v_obj))
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(v_obj), p_table:'MY_QRYMTH',p_idseq:this.v_idseq},
                    }).then(res=>{ 
                        if(res.code=='200'){
                            this.getMthList(this.v_idseq)
                            this.selClear()
                        }else{
                            this.promptWin =true
                            this.prompt =res.result
                        }
                    })
                }).catch(()=>{})
            }
        },
        getMthList(idseq){
            this.$axios.post(this.v_formurl,{
                p_key:'idseq',
                p_value:idseq,
                p_table:'V_MY_QRYMTH',
                p_key2:'userno',
                p_value2:this.v_username
            }).then(res=>{
                this.qryData =res.result
            })
  
        },
        btnExit(){
            this.$emit('child-exit')
        },
        btnQry(){
            let v_cond =''
            if (this.v_schema){
                this.qryData.forEach(item=>{
                    if (item['PKSEQ'] ==this.v_schema){
                        v_cond =item['SQLQRY'].replaceAll('@#','\'')
                    }
                })
            }else{
                if (this.sel01 && this.txt01){
                    if (this.oper01 =='like'){
                        v_cond =v_cond +' and lower('+this.sel01+') like lower(\'%'+this.txt01+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel01+')'+this.oper01+'  lower(\''+this.txt01+'\')'
                    }
                }
                if (this.sel02 && this.txt02){
                    if (this.oper02 =='like'){
                        v_cond =v_cond +' and lower('+this.sel02+') like lower(\'%'+this.txt02+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel02+')'+this.oper02+'  lower(\''+this.txt02+'\')'
                    }
                }
                if (this.sel03 && this.txt03){
                    if (this.oper03 =='like'){
                        v_cond =v_cond +' and lower('+this.sel03+') like lower(\'%'+this.txt03+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel03+')'+this.oper03+'  lower(\''+this.txt03+'\')'
                    }
                }
                if (this.sel04 && this.txt04){
                    if (this.oper04 =='like'){
                        v_cond =v_cond +' and lower('+this.sel04+') like lower(\'%'+this.txt04+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel04+')'+this.oper04+'  lower(\''+this.txt04+'\')'
                    }
                }
                if (this.sel05 && this.txt05){
                    if (this.oper05 =='like'){
                        v_cond =v_cond +' and lower('+this.sel05+') like lower(\'%'+this.txt05+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel05+')'+this.oper05+'  lower(\''+this.txt05+'\')'
                    }
                }
                if (this.sel06 && this.txt06){
                    if (this.oper06 =='like'){
                        v_cond =v_cond +' and lower('+this.sel06+') like lower(\'%'+this.txt06+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel06+')'+this.oper06+'  lower(\''+this.txt01+'\')'
                    }
                }
                if (this.sel07 && this.txt07){
                    if (this.oper07 =='like'){
                        v_cond =v_cond +' and lower('+this.sel07+') like lower(\'%'+this.txt07+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel07+')'+this.oper07+'  lower(\''+this.txt07+'\')'
                    }
                }
                if (this.sel08 && this.txt08){
                    if (this.oper08 =='like'){
                        v_cond =v_cond +' and lower('+this.sel08+') like lower(\'%'+this.txt08+'%\')'
                    }else{
                        v_cond =v_cond +' and lower('+this.sel08+')'+this.oper08+'  lower(\''+this.txt08+'\')'
                    }
                }     
            }
            this.$emit('child-query',v_cond)
        },
        //获取表列头字段  v-enter-number
        getTabCol(idseq,lstseq){
            var vm=this
            this.$axios.post(this.v_formurl,{
                p_key:'idseq',
                p_value:idseq,
                p_table:'v_sys_form_fld',
                p_key2:'lstseq',
                p_value2:lstseq,
                p_cond:' and thide=\'N\' order by sortby,lstseq'
            }).then(res=>{
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >

    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
